var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container-fluid scrollable" }, [
    _c("h1", [_vm._v("Preview features")]),
    _vm._v(" "),
    _c("h2", [_vm._v("TwoSidedMultiSelect")]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "w-75" },
      [
        _c("two-sided-multi-select", {
          attrs: { options: _vm.multiSelectOptions },
          model: {
            value: _vm.multiSelectValue,
            callback: function ($$v) {
              _vm.multiSelectValue = $$v
            },
            expression: "multiSelectValue",
          },
        }),
        _vm._v(" "),
        _c("pre", [
          _vm._v("    value: " + _vm._s(_vm.multiSelectValue) + "\n  "),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }